import API from '../index';

const voidOrder = async (orderId: string): Promise<boolean> => {
  await API.delete(`/orders/${orderId}`);
  return true;
};

export default voidOrder;
